module.exports = __webpack_public_path__ + "img/btn_reject.3b766c2b.svg";